import * as axios from 'axios';
import messages from '@/shared/modules/notifications';
import { API } from '@/shared/config';
import NProgress from 'nprogress';
import { saveToken, destroyToken, getToken } from '../auth';

// before a request is made start the nprogress
axios.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});
// before a response is returned stop nprogress
axios.interceptors.response.use((response) => {
  NProgress.done();
  return response;
},
(error) => {
  NProgress.done();
  if (error.response.status === 401) {
    destroyToken();
  }
  return Promise.reject(error);
});

axios.defaults.headers.common.Authorization = `Bearer ${getToken()}`;

const parseList = (response) => {
  if (response.status !== 200) throw Error(response.message);
  if (!response.data) return [];
  let list = response.data;
  if (typeof list !== 'object') {
    list = [];
  }
  return list;
};

const parseItem = (response, code) => {
  if (response.status !== code) throw Error(response.message);
  let item = response.data;
  if (typeof item !== 'object') {
    item = undefined;
  }
  return item;
};

const getMotorData = async () => {
  try {
    const response = await axios.get(`${API}/offer/motor`);
    const data = parseList(response);
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const getMotorAdminData = async (offer) => {
  try {
    const responseOffer = await axios.get(`${API}/offers/offer/${offer.offer}`);
    const responseGeneralData = await axios.get(`${API}/offer/motor`);
    const dataOffer = parseList(responseOffer);
    const dataGeneralData = parseList(responseGeneralData);
    const data = {
      data:
      {
        ...dataGeneralData.data,
        CS_DATA: { ...dataGeneralData.data.CS_DATA, ...dataOffer.CS_DATA }
      },
      lovs: dataGeneralData.lovs
    };
    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const getSearchVehicleData = async (data) => {
  try {
    const response = {
      PRODUCT: 'MOTOR',
      LICENSE_PLATE: 'ZZZ1045',
      CATEGORY: '01',
      MANUFACTURER: '01',
      MODEL: '01',
      CAPACITY: '1359',
      NR_OF_PASSANGER: 5,
      VALUE: '20000',
      YEAR: '122009',
      BIRTHDATE: '1991-01-01',
      LICENSE_DATE_ISSUE: '122009',
      OTHER_DRIVER_BIRTHDATE: '1991-01-01',
      OTHER_DRIVER_LICENSE_DATE_ISSUE: '122009',
      START_DATE: '',
      TYPE: '1',
      DURATION: '12'
    };
    if (data) {
      return response;
    } messages({ type: 'error', message: 'License plate not found!' });
  } catch (error) {
    console.error(error);
    return {};
  }
};

const getOfferPremiums = async (data) => {
  try {
    // const response = await axios.post('./api/motorData.json', offer);
    // console.log(response);
    // const data = parseList(response);
    console.log(data);
    const offer = data;
    offer.CT_MOTOR_INSURANCE_PLAN[0].PREMIUM = 100;
    offer.CT_MOTOR_INSURANCE_PLAN[1].PREMIUM = 200;
    offer.CT_MOTOR_INSURANCE_PLAN[2].PREMIUM = 300;
    return offer;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const getTravelData = async () => {
  try {
    const response = await axios.get('/api/motorData.json');
    const data = parseList(response);
    return data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const getHomeData = async () => {
  try {
    const response = await axios.get('/api/motorData.json');
    const data = parseList(response);
    return data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const getDriverData = async () => {
  try {
    const response = await axios.get('/api/motorData.json');
    const data = parseList(response);
    return data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const getHunterData = async () => {
  try {
    const response = await axios.get('/api/motorData.json');
    const data = parseList(response);
    return data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const addOffer = async (data) => {
  try {
    const response = await axios.post(`${API}/offers/add`, data);
    // console.log(response);
    const offer = parseItem(response, 201);
    console.log(offer);
    return offer;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getOffers = async () => {
  try {
    const response = await axios.get(`${API}/offers`);
    const data = parseList(response);
    return data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const deleteOffer = async (offer) => {
  try {
    const response = await axios.delete(`${API}/offers/delete/${offer}`);
    const deletedOffer = parseItem(response, 200);
    return deletedOffer;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getContracts = async () => {
  try {
    const response = await axios.get('/api/contractData.json');
    const data = parseList(response);
    return data.CT_CONTRACTS;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const registerUser = async (user) => {
  try {
    const response = await axios.post(`${API}/auth/register`, user);
    const data = parseItem(response, 201);
    messages({ type: 'info', message: 'User registrated successfully!' });
    saveToken(data);
    return data.username;
  } catch (error) {
    console.log(error);
    messages({ type: 'error', message: 'Username exists try another!' });
  }
};

const loginUser = async (credentials) => {
  try {
    const response = await axios.post(`${API}/auth/login`, credentials);
    // console.log(response);
    const data = parseList(response);
    saveToken(data);
    return data.username;
  } catch (error) {
    console.log(error);
    messages({ type: 'error', message: 'Wrong username or password!' });
  }
  // console.log(credentials);
  // if (credentials.username === 'improvit' && credentials.password === 'improvit') {
  //   const { username } = credentials;
  //   // const token = jwt.sign({ username }, 'the_secret_key', { expiresIn: '1s' });
  //   const token = jwt.sign({ username }, 'the_secret_key');
  //   const data = {
  //     username: credentials.username,
  //     token
  //   };
  //   saveToken(data);
  //   return data.username;
  // }
  // messages({ type: 'error', message: 'Wrong username or password!' });
  // messages({ type: 'info', message: 'Try user: "improvit", pw: "improvit"!' });
  // return '';
};

const logoutUser = async () => {
  await destroyToken();
};

const dataServices = {
  getMotorData,
  getMotorAdminData,
  addOffer,
  getOffers,
  deleteOffer,
  getOfferPremiums,
  getTravelData,
  getHomeData,
  getDriverData,
  getHunterData,
  getContracts,
  loginUser,
  logoutUser,
  registerUser,
  getSearchVehicleData
};
export default dataServices;
